<template>
  <span class="badge" :class="classes">
    <slot />
    <span
      v-if="$slots.badge"
      class="badge__badge"
      :style="badgeStyle"
      v-bind="$attrs"
    ><slot name="badge" /></span>
  </span>

</template>

<script>
export default {

  name: 'Badge',

  props: {
    color: {
      type: String,
      default: '#000000',
    },
    bottom: {
      type: Boolean,
    },
    left: {
      type: Boolean,
    },
  },

  computed: {
    classes() {
      return {
        'badge--bottom': this.bottom,
        'badge--left': this.left,
      };
    },
    badgeStyle() {
      return {
        'background-color': this.color,
        'border-color': this.color,
      };
    },
  },

};
</script>

<style lang="scss">
.badge {
  display: inline-block;
  position: relative;

  &__badge {
    color: #fff;
    display: flex;
    position: absolute;
    font-size: 10px;
    border-radius: 50%;
    width: 1.3rem;
    height: 1.3rem;
    top: -0.65rem;
    right: -0.65rem;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
  &--left .badge__badge {
    left: -17px;
  }
  &--bottom .badge__badge {
    bottom: -17px;
    top: initial;
  }
}
</style>
